(function () {
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('[data-swatch]');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();

    const card = swatch.closest('[data-product-card]');
    if (!card) return;
    const mainImage = card.querySelector('[data-main-image]');
    if (!mainImage) return;

    const src = swatch.dataset.variantImage;
    const srcset = swatch.dataset.variantSrcset;
    if (src) {
      mainImage.src = src;
      if (srcset) mainImage.srcset = srcset;
      // Keep the variant image visible even while hovering (otherwise the
      // secondary hover image would cover it).
      card.classList.add('has-variant-image');
    }

    card.querySelectorAll('[data-swatch]').forEach((s) => s.classList.remove('is-active'));
    swatch.classList.add('is-active');
  });
})();
